// extracted by mini-css-extract-plugin
export default {"container":"ScopeItem_container__3eeQw","selected":"ScopeItem_selected__k9flS","subItem":"ScopeItem_subItem__X4Zij","staticText":"ScopeItem_staticText__-EXhL"};